<template>
    <v-container style="max-width: 1240px; padding-left: 0px; padding-right: 0px;">
        <h3>Кредитный договор</h3>
        <v-layout row wrap class="less-paddings">
<!--            <v-flex xs12>
                <v-checkbox
                    label="Нет номера договора"
                    v-model="value.noContractNumber"
                    @change="deleteContractNumber"
                />
            </v-flex>-->
            <v-flex xs12 sm6 md3 lg2>
                <v-text-field pt0
                              label="Номер договора"
                              v-model="value.contract.number"
                              :rules="[rules.required]"
                />
            </v-flex>
            <p class="pt-1">
                <img class="tip-icon pt-3" src="/svg/q.svg" alt=""
                     data-tippy-animateFill="false"
                     data-tippy-animation="scale"
                     data-tippy-trigger="click"
                     :key="precalcInfo.bank"
                     :data-tippy-content="precalcInfo.bank === 'sber' ? 'Номер кредитного договора совпадает с номер заявки на ипотеку. Посмотреть номер заявки можно в личном кабинете Дом клик. Также номер кредитного договора можно запросить у менеджера в банке.' : creditNumberHelpText"
                />
            </p>
            <v-flex xs12 sm6 md3 lg2>
                <osago-date
                    label="Дата начала договора"
                    v-model="value.contract.dateStart"
                    :yearStarting="false"
                    min="2000-12-31"
                    :rules="[rules.required]"
                />
            </v-flex>
            <v-flex v-if="!(this.precalcInfo.bank === 'sber' || this.precalcInfo.bank === 'unicreditbank')" xs12 sm6 md3 lg2>
                <osago-date
                    label="Дата конца договора"
                    v-model="value.contract.dateEnd"
                    :yearStarting="false"
                    :min="value.contract.dateStart"
                />
            </v-flex>
            <p class="pt-1">
                <img class="tip-icon pt-3" src="/svg/q.svg" alt=""
                     data-tippy-animateFill="false"
                     data-tippy-animation="scale"
                     data-tippy-trigger="click"
                     data-tippy-content="ВАЖНО! Перепишите дату из документа. Она может отличаться от вашего подсчета."
                />
            </p>
        </v-layout>
        <v-layout row wrap class="less-paddings">
            <v-flex xs12 sm6 md3 lg2>
                <v-text-field
                    label="Ставка процента"
                    :rules="[rules.required, rules.float]"
                    v-model.number="value.contract.mortgageRate"
                    v-on:input="value.contract.mortgageRate = $event.replace(/,/, '.')"
                    v-on:focus="setFocus"
                    v-on:change="setFormat"
                    class="percent-input"
                >
                    <template slot="append">
                        <div class="percent-symbol">%</div>
                    </template>
                </v-text-field>
            </v-flex>
            <v-flex v-if="this.showAnnuityPayment" xs12 sm6 md3 lg2>
                <v-text-field
                    label="Ежемесячный платеж"
                    v-model.number="value.contract.annuityPayment"
                    :rules="[rules.required, rules.float]"
                />
            </v-flex>
            <v-flex xs1 style="max-width: 40px; align-self: flex-start" v-if="this.showAnnuityPayment">
                <p class="pt-1">
                    <img class="tip-icon pt-3" src="/svg/q.svg" alt=""
                         data-tippy-animateFill="false"
                         data-tippy-animation="scale"
                         data-tippy-trigger="click"
                         data-tippy-content="Указывайте точно как в документе, иначе банк может не принять полис."
                    />
                </p>
            </v-flex>
            <v-flex xs12 sm6 md6 lg4 v-if="this.showRateNumber && !this.showAnnuityPayment">
                <v-text-field
                    label="Ставка процента при отказе от страхования"
                    v-model.number="value.contract.creditPercentBetRefus"
                    :rules="[rules.required, rules.float, rules.percentRange, creditPercentBetRefus]"
                    v-on:input="value.contract.creditPercentBetRefus = $event.replace(/,/, '.')"
                    class="percent-input"
                >
                    <template slot="append">
                        <div class="percent-symbol">%</div>
                    </template>
                </v-text-field>
            </v-flex>
            <v-flex xs1 style="max-width: 40px; align-self: flex-start" v-if="this.showRateNumber && !this.showAnnuityPayment">
                <p class="pt-1">
                    <img class="tip-icon pt-3" src="/svg/q.svg" alt=""
                         data-tippy-animateFill="false"
                         data-tippy-animation="scale"
                         data-tippy-trigger="click"
                         data-tippy-content="Здесь нужно указать какую ставку по кредиту применит банк, если заемщик откажется от страхования жизни или объекта недвижимости. Информация указана в кредитном договоре."
                    />
                </p>
            </v-flex>
        </v-layout>
        <v-layout row wrap class="less-paddings">
            <v-flex xs12 sm6 md6 lg4 v-if="this.showRateNumber && this.showAnnuityPayment">
                <v-text-field
                    label="Ставка процента при отказе от страхования"
                    v-model.number="value.contract.creditPercentBetRefus"
                    :rules="[rules.required, rules.float, rules.percentRange, creditPercentBetRefus]"
                    v-on:input="value.contract.creditPercentBetRefus = $event.replace(/,/, '.')"
                    class="percent-input"
                >
                    <template slot="append">
                        <div class="percent-symbol">%</div>
                    </template>
                </v-text-field>
            </v-flex>
            <v-flex xs1 style="max-width: 40px; align-self: flex-start" v-if="this.showRateNumber && this.showAnnuityPayment">
                <p class="pt-1">
                    <img class="tip-icon pt-3" src="/svg/q.svg" alt=""
                         data-tippy-animateFill="false"
                         data-tippy-animation="scale"
                         data-tippy-trigger="click"
                         data-tippy-content="Здесь нужно указать какую ставку по кредиту применит банк, если заемщик откажется от страхования жизни или объекта недвижимости. Информация указана в кредитном договоре."
                    />
                </p>
            </v-flex>
        </v-layout>
        <h3>Срок действия <br>полиса</h3>
        <v-layout row wrap class="less-paddings">
            <v-flex sm6 md3 lg2>
                <osago-date
                    label="Дата начала"
                    v-model="value.policyStartDate"
                    :yearStarting="false"
                    :min="policyMinStartDate"
                    :max="policyMaxStartDate"
                />
            </v-flex>
            <v-flex sm6 v-if="duration === 'year' || value.contract.dateEnd">
                <p>Дата окончания полиса: {{ tempPolicyEndDate }}</p>
                <p>Дата окончания договора: {{ policyEndDate }}</p>
            </v-flex>
            <v-flex sm6 md3 lg2 v-else>
                <osago-date
                    label="Дата окончания"
                    v-model="value.policyEndDate"
                    :min="policyMinStartDate"
                />
            </v-flex>
        </v-layout>
        <h3>Данные <br>заемщика</h3>
        <v-layout row wrap align-end>
            <v-flex xs12 md6 lg4 py-0 style="align-self: flex-end">
                <osago-name
                    v-model="value.fio.surname"
                    label="Фамилия"
                />
            </v-flex>
            <v-flex xs12 md6 lg3 py-0>
                <osago-name
                    v-model="value.fio.name"
                    label="Имя"
                />
            </v-flex>
            <v-flex xs12 md6 lg3 py-0>
                <osago-name
                    v-model="value.fio.patronymic"
                    label="Отчество"
                    optional="true"
                    :noField.sync="value.fio.noPatronymic"
                    genitiveLabel="отчества"
                />
                <osago-name
                    v-if="value.fio.noPatronymic"
                    v-model="value.fio.patronymic"
                    label="Отчество"
                    :isDisabled="true"
                />
            </v-flex>
            <v-flex xs12 sm6 md2 lg2 py-0>
                <osago-date
                    v-model="value.birthday"
                    label="Дата рождения"
                    isBirthday="true"
                    :max="birthdayMinimal"
                    :isHideMobile="true"
                    :rules="[rules.required,rules.birthday]"
                />
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex>
                <v-text-field
                    label="Место рождения"
                    v-model="value.birthPlace"
                    :rules="[rules.required]"
                />
            </v-flex>
            <v-flex>
                <v-text-field
                    label="Рост"
                    v-model.number="value.height"
                    :rules="[rules.required, rules.digits]"
                    mask="###"
                />
            </v-flex>
            <v-flex>
                <v-text-field
                    label="Вес"
                    v-model.number="value.weight"
                    :rules="[rules.required, rules.digits]"
                    mask="###"
                />
            </v-flex>
        </v-layout>
        <h4>Паспорт</h4>
        <v-layout row wrap align-end>
            <v-flex xs12 sm6 md3 lg3>
                <v-text-field
                    v-model="value.passport.seriesNumber"
                    :rules="[rules.required,rules.passport]"
                    @paste="removeSpacesOnPaste($event, value.passport.seriesNumber)"
                    label="Серия и номер"
                    mask="#### ######"
                    return-masked-value
                    validation-on-blur
                    required
                    class="pt-1"
                />
            </v-flex>
            <v-flex xs12 sm6 md3 lg2>
                <osago-date
                    label="Дата выдачи"
                    v-model="value.passport.date"
                    :passportAgeCheck="minPassportDate"
                    :min="minPassportDate"
                    :max="dateToday"
                    :isHideMobile="true"
                />
            </v-flex>
            <v-flex xs12 sm6 md3>
                <v-text-field
                    v-model="value.passport.subdivisionCode"
                    :rules="[rules.required,rules.division]"
                    @paste="removeSpacesOnPaste($event, value.passport.seriesNumber)"
                    label="Код подразделения"
                    mask="###-###"
                    return-masked-value
                    validation-on-blur
                    required
                    class="pt-1"
                />
            </v-flex>
            <v-flex xs12 sm6 md4>
                <v-text-field
                    v-model="value.passport.issuedBy"
                    :rules="[rules.required]"
                    label="Кем выдан"
                    validation-on-blur
                    required
                    class="pt-1"
                />
            </v-flex>
        </v-layout>
        <h4>Адрес регистрации</h4>
        <v-layout row wrap align-end>
            <v-flex xs12>
                <osago-house-dadata
                    :model="value.registrationAddress"
                    :flat-check="value.equalRegistrationAddress"
                    :house-check="false"
                    @getCadastralNumber="getCadastralNumberByregistrationAddress"
                />
            </v-flex>
        </v-layout>
        <h3 xs12 v-if="precalcInfo.policyType.apartment">Данные по залоговой квартире</h3>
        <v-layout row wrap align-end v-if="precalcInfo.policyType.apartment">
            <v-flex xs12>
                <v-checkbox
                    label="Совпадает с адресом регистрации"
                    v-model="value.equalRegistrationAddress"
                    @change="changeMortgageAddress"
                >
                </v-checkbox>
                <osago-house-dadata
                    v-if="!value.equalRegistrationAddress"
                    :model="value.mortgageAddress"
                    :flat-check="true"
                    :house-check="false"
                    @getCadastralNumber="getCadastralNumber"
                />
            </v-flex>
        </v-layout>
        <v-layout row wrap v-if="precalcInfo.policyType.apartment">
            <v-flex lg4 md4>
                <v-text-field
                    label="Этажность дома"
                    v-model.number="value.floorsNumber"
                    :rules="[rules.required, rules.digits]"
                    mask="###"
                />
            </v-flex>
            <v-flex lg4 md4>
                <v-text-field
                    label="Год постройки"
                    v-model.number="value.buildYear"
                    :rules="[rules.required, rules.digits]"
                    mask="####"
                />
            </v-flex>
            <v-flex lg4 md4>
                <v-text-field
                    label="Площадь квартиры, кв.м"
                    v-model.number="value.apartmentArea"
                    :rules="[rules.required, rules.float]"
                    @input="onApartmentArea"
                />
            </v-flex>
            <v-flex lg6 md4 v-if="precalcInfo.policyType.apartment && this.showCadastralNumber">
                <v-checkbox
                    label="Кадастровый номер отсутствует"
                    v-model="value.noCadastralNumber"
                    @change="addMaskToCadastralNumber"
                >
                </v-checkbox>
                <v-text-field
                    v-if="!value.noCadastralNumber"
                    label="Кадастровый номер"
                    v-model.string="value.cadastralNumber"
                    :rules="[rules.required]"
                    :loading="isWaitingUpdateRequest"
                />
            </v-flex>
            <v-flex
                xs12 md6
                class="prev-policy"
                v-if="this.showErrorWhenGetCadastralNumber && this.showCadastralNumber && !value.noCadastralNumber"
            >
                <div class="prev-policy-label">
                    <p>Не удалось найти кадастровый номер.</p>
                    <p>1.Убедитесь что вы выбрали адрес из выпадающего списка.</p>
                    <p>2.Введите кадастровый номер вручную.</p>
                    <p>В поиске может помочь сайт ФИАС <a href="https://fias.nalog.ru/" target="_blank">https://fias.nalog.ru/</a></p>
                </div>
            </v-flex>
            <v-flex
                xs12 md6
                class="prev-policy"
                v-if="isWaitingUpdateRequest && !value.noCadastralNumber"
            >
                <span class="prev-policy-wait">
                    {{ 'Идёт поиск кадастрового номера...' }}
                </span>
            </v-flex>
        </v-layout>
        <osago-user
            titleText = "Контакты для получения полиса"
            :phoneInputText = "phoneInputText"
            :attentionText = "attentionText"
            :attentionPhoneText = "attentionPhoneText"
            :b2c = "false"
            :hidePhone = "false"
            v-model="value.user"
        />
    </v-container>
</template>

<script>
import moment from "moment";
import helperMixin from '../../mixins/helper';

export default {
    name: "MortgageCalcInfo",
    mixins: [helperMixin],
    props: {
        value: {
            type: Object,
            default: {
                noContractNumber: false,
                contract: {
                    number: '',
                    dateStart: null,
                    dateEnd: null,
                    mortgageRate: null,
                    annuityPayment: null,
                    creditPercentBetRefus: null,
                },
                policyStartDate: null,
                policyEndDate: null,
                user: {
                    phone: '7',
                    email: null,
                },
                fio: {
                    name: null,
                    surname: null,
                    patronymic: null
                },
                birthday: null,
                birthPlace: null,
                passport: {
                    date: null,
                    seriesNumber: null,
                    subdivisionCode: null,
                    issuedBy: null
                },
                registrationAddress: {
                    search: null,
                    city: null,
                    street: null,
                    house: null,
                    house_kladr: null,
                    house_fias: null,
                    flat: null,
                    flat_cadnum: null,
                    city_fias_id: null,
                    postalCode: null,
                    region: null,
                },
                mortgageAddress: {
                    search: null,
                    city: null,
                    street: null,
                    house: null,
                    house_kladr: null,
                    house_fias: null,
                    flat: null,
                    flat_cadnum: null,
                    city_fias_id: null,
                    postalCode: null,
                    region: null,
                },
                buildYear: null,
                floorsNumber: null,
                apartmentArea: null,
                cadastralNumber: null,
                noCadastralNumber: false,
            }
        },
        duration: String,
        precalcInfo: Object,
        uuid: String,
    },
    data: () => ({
        dateToday: null,
        birthdayMinimal: null,
        policyMinStartDate: null,
        policyMaxStartDate: null,
        phoneInputText: "Телефон, будет логином для входа в личный кабинет",
        attentionPhoneText: "Обязательно указать актуальный контактный телефон клиента",
        attentionText: '<b>ВАЖНО!</b> Проверьте правильность<br>e-mail, на него придет электронный полис',
        rules: {
            required: v => !!v || 'Поле обязательно для заполнения',
            digits: v => Number.isInteger(v) || 'Значение должно быть целым числом',
            float: v => !isNaN(parseFloat(v)) || 'Значение должно быть дробным или целым числом',
            passport: v => /^\d{4} \d{6}$/.test(v) || 'Неверный формат',
            division: v => /^\d{3}-\d{3}$/.test(v) || 'Неверный формат',
            birthday: v => this.validBirthday(v),
            percentRange: v => (v >= 0.1 && v <= 100) || 'Значение должно быть от 0.1 до 100',
            creditPercentBetRefus: v => (Number(v) >= Number(this.value.contract.mortgageRate)) || 'Значение должно быть не меньше чем в поле "Ставка процента"',
        },
        banksForRateNubmer: [
            'sber',
            'fk_otkritie_bank',
            'mkb',
            'domrfbank',
            'uralsib_bank',
            'raiffeisen',
            'gazprombank',
            'vtb',
            'akbarsbank',
            'levoberezhnii_bank',
            'bspb',
            'abr',
            'alfabank',
            'bzhf',
        ],
        showRateNumber: false,
        banksForCadastralNumber: [
            'vtb',
            'gazprombank',
            'unicreditbank',
            'domrfbank',
            'uralsib_bank',
            'raiffeisen',
            'akbarsbank',
            'levoberezhnii_bank',
            'sber',
            'psbank',
            'fk_otkritie_bank',
            'mkb',
        ],
        showCadastralNumber: false,
        banksForAnnuityPayment : [
            'vtb',
            'bzhf'
        ],
        showAnnuityPayment: false,
        hintText: null,
        showErrorWhenGetCadastralNumber: false,
        isWaitingUpdateRequest: false,
        creditNumberHelpText: 'Номер кредитного договора можно узнать у персонального менеджера в банке. Например, запросив у него фото первой страницы графика платежей, можно с монитора компьютера.',
    }),
    updated: () => {
        window.tippy.default('.tip-icon');
    },
    watch:{
        'value.birthday' : {
            handler: function(val, oldVal) {
                this.changeBirthday(val)
            },
            deep: true
        },
        'precalcInfo.bank'(value) {
            this.showCadastralNumber = this.banksForCadastralNumber.includes(value)
            this.showRateNumber = this.banksForRateNubmer.includes(value)
            this.showAnnuityPayment = this.banksForAnnuityPayment.includes(value)
            this.setValueOfCreditPercentBetRufus();
        },
        tempPolicyEndDate: {
            handler: function (val) {
                this.$emit('changeTempPolicyEndDate', val);
            },
            deep: true
        }
    },
    computed: {
        policyEndDate() {
            if (!this.value.policyStartDate) {
                return '';
            }
            if (!(this.precalcInfo.bank === 'sber' || this.precalcInfo.bank === 'unicreditbank')) {
                this.value.policyEndDate = this.value.contract.dateEnd;
                return moment(this.value.contract.dateEnd).format('DD.MM.YYYY')
            }
            if(this.duration == 'year') {
                return moment(this.value.policyStartDate).add(1, 'year').subtract(1, 'day').format('DD.MM.YYYY')
            }
            return this.value.policyEndDate
        },
        gender() {
            if (!this.value.fio.patronymic) {
                return null;
            }
            return this.value.fio.patronymic.endsWith('а') ? 'f' : 'm';
        },
        minPassportDate() {
            if (!this.value.birthday) {
                return null;
            }
            return moment(this.value.birthday).add(14, 'year').format('YYYY-MM-DD');
        },
        tempPolicyEndDate() {
            if (this.value.policyStartDate && this.value.contract.dateEnd) {
                const policyStartDate = moment(this.value.policyStartDate);
                const contractDateEnd = moment(this.value.contract.dateEnd);
                const oneYearLater = policyStartDate.clone().add(1, 'year').subtract(1, 'day');

                return contractDateEnd.diff(policyStartDate, 'days') >= 365 ? oneYearLater.format('DD.MM.YYYY') : contractDateEnd.format('DD.MM.YYYY');
            }
        },
    },
    created() {
        this.policyMinStartDate = moment().add(1, 'hour').format('YYYY-MM-DD');
        this.policyMaxStartDate = moment(this.policyMinStartDate).add(2, 'month').format('YYYY-MM-DD');
        this.birthdayMinimal = moment().subtract(18, 'year').format('YYYY-MM-DD');
        this.dateToday = moment().format('YYYY-MM-DD');
        this.showCadastralNumber = this.banksForCadastralNumber.includes(this.precalcInfo.bank);
        this.showRateNumber = this.banksForRateNubmer.includes(this.precalcInfo.bank);
        this.showAnnuityPayment = this.banksForAnnuityPayment.includes(this.precalcInfo.bank);
        if (this.value.mortgageAddress.search) {
            axios.get('/get-cadastral-number/' + this.uuid)
                .then(response => {
                    response.data.cadastralNumber == null ? this.showErrorWhenGetCadastralNumber = true : this.value.cadastralNumber = response.data.cadastralNumber;
                })
                .catch(error => {
                    console.log(error)
                })
        };
        this.value.noCadastralNumber ? this.value.cadastralNumber = '_____________' : this.value.cadastralNumber = '';
        this.value.contract.dateStart = this.value.contract.dateStart || this.precalcInfo.contract.dateStart;
        this.$emit('changeTempPolicyEndDate', this.tempPolicyEndDate);
    },
    methods: {
        setFocus() {
            if (this.value.contract.mortgageRate) this.value.contract.mortgageRate = this.value.contract.mortgageRate.toString().replace(/\s/g, '')
        },
        setFormat(value) {
            if (!value) {
                this.value.contract.creditPercentBetRefus = null;
                return;
            }
            let sum = value.replace(/\s/g, '')
            sum = Math.floor(Math.round(parseFloat(sum) * 100)) / 100
            this.value.contract.mortgageRate = sum.toString().replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ')
            this.countFloatSymbols(this.value.contract.mortgageRate) === 1 ? this.value.contract.mortgageRate += '0' : {}
            this.setValueOfCreditPercentBetRufus();
        },
        countFloatSymbols(x) {
            return x.includes('.') ? x.split('.').pop().length : 0
        },
        changeBirthday(value) {
            this.$emit('changeBirthday', value)
        },
        validBirthday(date) {
            const m = moment(date, 'DD.MM.YYYY');
            const isValid = m.format('DD.MM.YYYY') === date;
            if (!isValid) return 'Неверный формат даты';

            const diff = moment().diff(m, 'years');
            if (diff < 18) return 'Меньше 18 лет';
            if (diff > 75) return 'Больше 75 лет';

            return true;
        },

        onApartmentArea(value) {
            let string = value.replace(/,/, '.').replace(/(?!-)[^0-9.]/g, "")
            if (string.length > 4 && !string.includes('.')) {
                string = string.substr(0, 4) + '.' + string.substr(4, string.length)
            }
            if([...string].filter(l => l === '.').length > 1) {
                let lastPointPosition = string.lastIndexOf('.')
                string = string.slice(0, lastPointPosition) + string.slice(lastPointPosition + 1);
            }
            if(string.includes('.')) {
                let float = string.split('.')
                if (float[0] > 4) {
                    float[0] = float[0].slice(0, 4)
                }
                if (float[1] > 2) {
                    float[1] = float[1].slice(0, 2)
                }
                string = float.join('.')
            }
            this.$emit('changeApartmentArea', string)
        },
        deleteContractNumber() {
            this.$emit('deleteContractNumber');
        },
        changeMortgageAddress() {
            this.$emit('updateRegistrationAddress')
            if (this.value.equalRegistrationAddress && !this.value.noCadastralNumber) {
                this.getCadastralNumber();
            }
        },
        getCadastralNumber() {
            this.value.cadastralNumber = '';
            this.showErrorWhenGetCadastralNumber = false;
            this.isWaitingUpdateRequest = true;
            setTimeout(() => {
                axios.get('/get-cadastral-number/' + this.uuid)
                    .then(response => {
                        response.data.cadastralNumber == null ? this.showErrorWhenGetCadastralNumber = true : this.value.cadastralNumber = response.data.cadastralNumber;
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        this.isWaitingUpdateRequest = false;
                    })
            }, 15000)
        },
        getCadastralNumberByregistrationAddress() {
            if (!this.value.equalRegistrationAddress) {
                return;
            }
            this.getCadastralNumber();
        },
        addMaskToCadastralNumber() {
            this.value.noCadastralNumber ? this.value.cadastralNumber = '_____________' : this.value.cadastralNumber = '';
        },
        creditPercentBetRefus(v) {
            return Number(v) >= Number(this.value.contract.mortgageRate) || 'Не может быть меньше, чем "Ставка процента"';
        },
        setValueOfCreditPercentBetRufus() {
            this.value.contract.mortgageRate ? this.value.contract.creditPercentBetRefus = parseFloat(this.value.contract.mortgageRate) + 1 : this.value.contract.creditPercentBetRefus;
            if (this.value.contract.mortgageRate && this.precalcInfo.bank === 'alfabank') {
                this.value.contract.creditPercentBetRefus = parseFloat(this.value.contract.mortgageRate) + 2;
            }
        },
    }
}
</script>

<style scoped>
.prev-policy {
    padding: 55px 10px 0px !important;
}

.prev-policy-label {
    display: inline-block;
    font-size: 14px;
    margin-top: 4px;
    color: red;
}

.prev-policy-wait {
    display: inline-block;
    font-size: 14px;
    margin-top: 4px;
    color: #00ba57;
}

.prev-policy-label p {
    margin-bottom: 0;
}

.prev-policy-label a {
    font-size: 14px;
}
.percent-input {
    position: relative;
}

.percent-symbol {
    position: absolute;
    top: 50%;
    right: 8px; /* Регулируйте отступ в зависимости от вашего дизайна */
    transform: translateY(-50%);
    font-size: 16px; /* Регулируйте размер шрифта по необходимости */
}

.tip-icon {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/mortgage/MortgageCalcInfo.vue